/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoBreedLogListBreedLogData model module.
 * @module model/LogControllerDtoBreedLogListBreedLogData
 * @version 1.0
 */
class LogControllerDtoBreedLogListBreedLogData {
    /**
     * Constructs a new <code>LogControllerDtoBreedLogListBreedLogData</code>.
     * @alias module:model/LogControllerDtoBreedLogListBreedLogData
     */
    constructor() { 
        
        LogControllerDtoBreedLogListBreedLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoBreedLogListBreedLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoBreedLogListBreedLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoBreedLogListBreedLogData} The populated <code>LogControllerDtoBreedLogListBreedLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoBreedLogListBreedLogData();

            if (data.hasOwnProperty('nftMintingNo')) {
                obj['nftMintingNo'] = ApiClient.convertToType(data['nftMintingNo'], 'Number');
            }
            if (data.hasOwnProperty('nftMotherUid')) {
                obj['nftMotherUid'] = ApiClient.convertToType(data['nftMotherUid'], 'Number');
            }
            if (data.hasOwnProperty('nftFatherUid')) {
                obj['nftFatherUid'] = ApiClient.convertToType(data['nftFatherUid'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('mintingTransactionNo')) {
                obj['mintingTransactionNo'] = ApiClient.convertToType(data['mintingTransactionNo'], 'Number');
            }
            if (data.hasOwnProperty('xper')) {
                obj['xper'] = ApiClient.convertToType(data['xper'], 'Number');
            }
            if (data.hasOwnProperty('per')) {
                obj['per'] = ApiClient.convertToType(data['per'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoBreedLogListBreedLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoBreedLogListBreedLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} nftMintingNo
 */
LogControllerDtoBreedLogListBreedLogData.prototype['nftMintingNo'] = undefined;

/**
 * @member {Number} nftMotherUid
 */
LogControllerDtoBreedLogListBreedLogData.prototype['nftMotherUid'] = undefined;

/**
 * @member {Number} nftFatherUid
 */
LogControllerDtoBreedLogListBreedLogData.prototype['nftFatherUid'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoBreedLogListBreedLogData.prototype['nftUid'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoBreedLogListBreedLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoBreedLogListBreedLogData.prototype['email'] = undefined;

/**
 * @member {Number} mintingTransactionNo
 */
LogControllerDtoBreedLogListBreedLogData.prototype['mintingTransactionNo'] = undefined;

/**
 * @member {Number} xper
 */
LogControllerDtoBreedLogListBreedLogData.prototype['xper'] = undefined;

/**
 * @member {Number} per
 */
LogControllerDtoBreedLogListBreedLogData.prototype['per'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoBreedLogListBreedLogData.prototype['createdAt'] = undefined;

/**
 * @member {Date} updatedAt
 */
LogControllerDtoBreedLogListBreedLogData.prototype['updatedAt'] = undefined;






export default LogControllerDtoBreedLogListBreedLogData;

